<template>
	<div class="wrapper">
		<section class="data-cont mould-index">
			<h3 class="fx fx-x-between fx-y-center count-title">
				<div class="fx">
					<p>平台数据统计</p>
					<div class="question-cont">
						<i class="icon-question "></i>
						<div class="question-explain">
							<h5>平台数据统计</h5>
							<p>平台级数据汇总</p>
						</div>
					</div>
				</div>
				<div>
					<el-date-picker
					  v-model="stasticDate"
				      type="daterange"
				      align="right"
				      placeholder="选择日期范围(默认全部)"
				      :picker-options="pickerOptions"
				      @change="handleGetStatisticsCount">
				    </el-date-picker>
				</div>
			</h3>
			<div class="count-wapper">
				<div class="all-count member-cont">
					<div class="member-data">
						<ul class="fx text-center">
							<li class="fx-fill">
                                <strong>{{count.orderNum}}</strong>
                                <p>{{stasticDate[0] ? '':'（全部）' }}交易总笔数（单位/笔）</p>
                            </li>
                            <li class="fx-fill">
                                <strong>{{count.orderMoney | filterMoney}}</strong>
                                <p>{{stasticDate[0] ? '':'（全部）' }}交易总金额（单位/元）</p>
                            </li>
						</ul>
					</div>
				</div>
				<div class="p-t-20 p-b-20">
					<ul class="fx fx-wrap">
						<li>
                            <dl class="text-center">
                                <dt>商户</dt>
                                <dd>{{stasticDate[0] ? '':'（全部）' }}总商户数（个）：<i>{{count.usersNum}}</i></dd>
                                <dd>{{stasticDate[0] ? '':'（全部）' }}认证商户数（个）：<i>{{count.usersAttNum }}</i></dd>
                                <dd>{{stasticDate[0] ? '':'（全部）' }}总门店数（个）：<i>{{count.shopsNum }}</i></dd>
                            </dl>
                        </li>
						<li>
							<dl class="text-center">
								<dt>公众号</dt>
								<dd>{{stasticDate[0] ? '':'（全部）' }}接入总数（个）：<i>{{count.authorizedNum + count.unauthorizedNum}}</i></dd>
                                 <dd>{{stasticDate[0] ? '':'（全部）' }}授权总数（个）：<i>{{count.authorizedNum}}</i></dd>
                                 <dd>{{stasticDate[0] ? '':'（全部）' }}取消授权数（个）：<i>{{count.unauthorizedNum}}</i></dd>
							</dl>
						</li>
                        <li>
                            <dl class="text-center">
                                <dt>C端用户</dt>
                                <dd>{{stasticDate[0] ? '':'（全部）' }}总用户数（个）：<i>{{count.memberCount}}</i></dd>
                                <dd>{{stasticDate[0] ? '':'（全部）' }}微信用户数（个）：<i>{{count.wxCount}}</i></dd>
                                <dd>{{stasticDate[0] ? '':'（全部）' }}支付宝用户数（个）：<i>{{count.zfbCount}}</i></dd>
                            </dl>
                        </li>
                        <li>
                            <dl class="text-center">
                                <dt>其他</dt>
                                <dd>{{stasticDate[0] ? '':'（全部）' }}待定：<i>0</i></dd>
                                <dd>{{stasticDate[0] ? '':'（全部）' }}待定：<i>0</i></dd>
                                <dd>{{stasticDate[0] ? '':'（全部）' }}待定：<i>0</i></dd>
                            </dl>
                        </li>
					</ul>
				</div>
			</div>
		</section>
		<section class="data-cont mould-index m-t-20">
			<h3 class="fx fx-x-between fx-y-center">
				<div class="fx fx-y-center">
					<div class="fx">
						<p>平台交易趋势</p>
						<div class="question-cont">
							<i class="icon-question "></i>
							<div class="question-explain">
								<h5>交易金额</h5>
								<p>交易金额趋势图分析</p>
								<h5>交易笔数</h5>
								<p>交易笔数趋势图分析</p>
							</div>
						</div>
					</div>
				</div>
				<z-daybar :on-click="handleGetStatisticsTrend"></z-daybar>
			</h3>
			<div class="m-t-20" id="trendData" style="width:auto;height: 400px;"></div>
		</section>
	</div>
</template>
<script>
	import {
		mapActions,
		mapState
	} from 'vuex'
	export default {
		name: 'Index',
		data() {
			return {
				stasticDate:[],
				pickerOptions: {
					shortcuts: [{
						text: '最近7天',
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
							picker.$emit('pick', [start, end]);
						}
					}, {
						text: '最近15天',
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 15);
							picker.$emit('pick', [start, end]);
						}
					}, {
						text: '最近30天',
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
							picker.$emit('pick', [start, end]);
						}
					}]
				},
				trendChart:null,
				trendOption: {
					tooltip: {
						trigger: 'axis'
					},
					legend: {
						data: ['交易金额', '交易笔数']
					},
					grid: {
						left: '3%',
						right: '4%',
						//				        bottom: '3%',
						containLabel: true
					},
					xAxis: {
						type: 'category',
						boundaryGap: false,
						data: []
					},
					yAxis: {
						type: 'value'
					},
					series: [{
							name: '交易金额',
							type: 'line',
							stack: '金额',
							data: []
						}, {
							name: '交易笔数',
							type: 'line',
							stack: '数量',
							data: []
						}
					]
				},
			}
		},
		mounted() {
			this.handleGetStatisticsCount()
			this.handleGetStatisticsTrend(7)
			this.initEcharts()
			window.onresize = () =>{
				this.trendChart.resize();
			}
		},
		computed: {
			...mapState({
				count: state => state.mgHome.count
			})
		},
		
		methods: {
			initEcharts() {
				//初始化图表
				this.trendChart = this.$echartsInit('trendData', {
					width: 'auto',
					height: 400
				})
				this.trendChart.setOption(this.trendOption);
			},
			async handleGetStatisticsTrend(day){
				const data = await this.getMgStatisticsTrend({day})
				const dates = [],
						counts = [],
						totals = []
				data.map((item,index)=>{
					dates.push(item.day)
					counts.push(this.$filterMoney(item.count))
					totals.push(item.total)
				})
				
				this.trendChart.setOption({
					xAxis: {
						data:dates
					},
					series: [{
							data: counts
						},
						{
							data: totals
						}
					]
				})
			},
			handleGetStatisticsCount() {
				let params = {
					startDate: this.stasticDate.length > 0 ? this.stasticDate[0]:'',
					endDate: this.stasticDate.length > 0 ? this.stasticDate[1]:''
				}
				this.getMgStatisticsCount(params)
			},
			...mapActions(['getMgStatisticsCount','getMgStatisticsTrend']),
		}
	}
</script>
<style lang="scss" scoped>
	@import "src/assets/css/common.scss";
	.mould-index{
		box-shadow: 0 2px 4px rgba(0,0,0,0.1);
	}
	.data-cont{
		border: none !important;
		.count-title{
			padding: px-em(30px) px-em(40px);
			border-bottom: 1px solid $color-border;
		}
		.btn-check{
			padding: px-em(10px) px-em(20px);
			background: $color-main;
			color: $color-white;
			border-radius: 2px;
			cursor: pointer;
			transition: all 0.2s ease; 
			&:hover{
				background: lighten($color-main,10%);
			}
			&:active{
				transform: scale(0.98);
				background: darken($color-main,10%);
			}
		}
		.day-type {
			ol li {
				+li {
					border-left: none;
				}
				transition: all 0.2s ease;
				padding: px-em(10px) px-em(20px);
				cursor: pointer;
				border: 1px solid $color-border;
				&:hover {
					background: rgba(0, 0, 0, 0.1);
				}
				&.active {
					background: rgba(0, 0, 0, 0.1);
				}
			}
		}
	}
	.count-wapper{
		padding: 0 px-em(40px);
		.all-count{
			border-bottom: 1px solid $color-border;
		}
		li{
			width: 25%;
			padding: px-em(20px) px-em(40px) px-em(40px) 0;
			dl{
				padding: 0 px-em(40px);
				background: $color-white;
				dt{
					padding: px-em(20px) 0;
					font-size: px-em(32px);
				}
				dd{
					a{
						color: $color-font-sub; 
						&:hover{
							color: $color-main;
							text-decoration: underline;
						}
					}
					padding: px-em(16px) 0;
					i{
						color: $color-main;
						font-weight: bold;
						font-size: px-em(32px);
					}
					&:nth-child(2){
						padding-top: px-em(20px);
					}
				}
			}
			&:nth-child(4n){
				padding-right: 0;
			}
		}
	}
	.chart-wapper{
		margin: 0 20px;
		border-top: 1px solid $color-border;
		position: relative;
		padding-top: 50px;
		.day-type{
			position: absolute;
			right: 20px;
			top: 15px;
		}
	}
	@media only screen and (min-width:0px) and (max-width:640px) {
		.mould-index{
			.member-data p{
				font-size: px-em(24px);
			}
		}
		.member-data{
			padding: px-em(40px) px-em(40px) !important;
			li{
				padding: 0 px-em(20px);
			}
		}
	}
</style>


// WEBPACK FOOTER //
// Index.vue?b54ab6c8